import React from 'react';
import PropTypes from 'prop-types';
import DayPickerInput from 'react-day-picker/DayPickerInput'
import _ from 'lodash';

import { NAMES } from './schedule_constants';
import { getDateValue } from '../../utils/date';

function greater (v1, v2) {
  if (v1 && v2) return (v1 > v2 ? v1 : v2);
  return v1 || v2;
}


// This function return the limits to the left, right, above, below
// the current date in the form. These values are useful for validations
// in DateField which checks if entered value falls between above and below.

export function getDateLimits (MILESTONES, schedule, milestone, name) {
  const mIndex = MILESTONES.indexOf(milestone);
  const nIndex = NAMES.indexOf(name);
  let dateAbove, dateBelow, dateLeft, dateRight;
  let nameAbove, nameBelow, nameLeft, nameRight;

  // There could be more performant versions of this. But this is the best
  // I could do without sacrificing readability

  for (const m of MILESTONES.slice(0, mIndex).reverse()) {
    const value = schedule[m][name];
    if (schedule[m][name]) {
      dateAbove = value;
      nameAbove = m;
      break;
    }
  }

  for (const m of MILESTONES.slice(mIndex + 1)) {
    const value = schedule[m][name];
    if (value) {
      dateBelow = value;
      nameBelow = m;
      break;
    }
  }

  for (const n of NAMES.slice(0, nIndex).reverse()) {
    const value = schedule[milestone][n];
    if (value) {
      dateLeft = value;
      nameLeft = n;
      break;
    }
  }

  for (const n of NAMES.slice(nIndex + 1)) {
    const value = schedule[milestone][n];
    if (value) {
      dateRight = value;
      nameRight = n;
      break;
    }
  }

  return {
    dateAbove, dateBelow, dateLeft, dateRight,
    nameAbove, nameBelow, nameLeft, nameRight,
  }
}

export class DateField extends React.Component {
  // static PropTypes = {
    // value: PropTypes.string,
    // limits: PropTypes.object.isRequired,
    // isValid: PropTypes.bool,
    // errorText: PropTypes.string,
    // masterMode: PropTypes.bool,
    // onChange: PropTypes.func.isRequired,
  // }

  constructor (props) {
    super(props);
    this.state = {
      isValid: true,
      saving: false,
      errorText: '',
      hasFocus: false,
      value: getDateValue(props.value)
    };
    this.setLimits(props.limits);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setLimits(nextProps.limits)
  }

  setLimits (limits) {
    this.limits = _.mapValues(limits, (v) => v && new Date(v))
  }

  getDatePickerProps (value, limits) {
    const month = limits.month || greater(limits.dateAbove, limits.dateLeft);
    const start = limits.dateAbove;
    const end = limits.dateBelow;
    const config = {};

    if (!value && month) config.month = month;
    if (this.props.masterMode) return config;

    // These lines will disallow navigation to months before or after
    // if (start) _.set(config, 'fromMonth', start);
    // if (end) _.set(config, 'toMonth', end);

    if (start || end) {
      _.set(config, 'modifiers.disabled', function (day) {
        return (start && day < start);
      });
    }

    return config;
  }

  handleChange (day) {
    const value = day ? day.format('L') : '';
    this.props.onChange(value);
  }
  handleKeyDown(event) {
    if (this.props.disableManualEntry){
      event.preventDefault();
    }
  }

  render () {
    const { value, isValid, errorText, placeholder } = this.props;
    const dayPickerProps = this.getDatePickerProps(value, this.limits)
    const tooltipClass = 'tooltip' + (this.state.hasFocus ? ' has-focus' : '')

    return (
      <div className={'date-field' + (isValid ? '' : ' has-error')}>
        <DayPickerInput
          value={getDateValue(value)}
          format="L"
          dayPickerProps={dayPickerProps}
          onDayChange={this.handleChange}
          onFocus={() => this.setState({hasFocus: true})}
          onBlur={() => this.setState({hasFocus: false})}
          onKeyDown = {this.handleKeyDown}
          placeholder={placeholder}
        />
        { errorText ? <div className={tooltipClass}>{errorText}</div> : null }
      </div>
    );
  }
}

DateField.defaultProps = {
     masterMode: false,
     errorText: '',
     isValid: true
}

DateField.propTypes = {
  value: PropTypes.string,
  limits: PropTypes.object.isRequired,
  isValid: PropTypes.bool,
  errorText: PropTypes.string,
  masterMode: PropTypes.bool,
  disableManualEntry: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

export function getDateLimitsActual (MILESTONES, schedule, milestone, name) {

    const mIndex = MILESTONES.indexOf(milestone);
    const nIndex = NAMES.indexOf(name);
    let dateAbove, dateBelow, dateLeft, dateRight;
    let nameAbove, nameBelow, nameLeft, nameRight;
  
    // There could be more performant versions of this. But this is the best
    // I could do without sacrificing readability
  
    for (const m of MILESTONES.slice(0, mIndex).reverse()) {
      const value = schedule[m][name];
      if (schedule[m][name]) {
        dateAbove = value;
        nameAbove = m;
        break;
      }
    }
  
    for (const m of MILESTONES.slice(mIndex + 1)) {
      const value = schedule[m][name];
      if (value) {
        dateBelow = value;
        nameBelow = m;
        break;
      }
    }
  
    for (const n of NAMES.slice(0, nIndex).reverse()) {
      const value = schedule[milestone][n];
      if (value) {
        dateLeft = value;
        nameLeft = n;
        break;
      }
    }
  
    for (const n of NAMES.slice(nIndex + 1)) {
      const value = schedule[milestone][n];
      if (value) {
        dateRight = value;
        nameRight = n;
        break;
      }
    }
  
    return {
      dateAbove, dateBelow, dateLeft, dateRight,
      nameAbove, nameBelow, nameLeft, nameRight,
    }
  }
  
export class DateFieldActual extends React.Component {
  // static PropTypes = {
  //   value: PropTypes.string,
  //   limits: PropTypes.object.isRequired,
  //   isValid: PropTypes.bool,
  //   errorText: PropTypes.string,
  //   masterMode: PropTypes.bool,
  //   onChange: PropTypes.func.isRequired,
  // }

  constructor(props) {
    super(props);
    this.state = {
      isValid: true,
      saving: false,
      errorText: '',
      hasFocus: false,
      value: getDateValue(props.value)
    };
    this.setLimits(props.limits);
    this.handleChange = this.handleChange.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setLimits(nextProps.limits)
  }

  setLimits(limits) {
    this.limits = _.mapValues(limits, (v) => v && new Date(v))
  }

  getDatePickerPropsActual(value, limits) {
    const month = limits.month || greater(limits.dateAbove, limits.dateLeft);

    const start = limits.dateAbove;
    const end = limits.dateBelow;

    const config = {};

    if (start !== undefined || end !== undefined) {
    // var startActual = new Date(start);
    // startActual.setDate(start.getDate()-1);

    if (!value && month) config.month = month;
    if (this.props.masterMode) return config;

   var dateTimeNow = new Date();

    // if date below is empty -> disable values from today
    if (!end){ 
      _.set(config, 'modifiers.disabled', function(day) {
         if (day > dateTimeNow)
          return (day > dateTimeNow);
        if (day < start)
          return (day < start)
      });
    }

    // set date between above and below values if below date is less than today
     if ((start || end) && (end < dateTimeNow)) { 
    //  if ((start || end)) { 
      _.set(config, 'modifiers.disabled', function(day) {
        if(day < start) 
          return (day < start) 
        if(day > end) 
       return (day > end);
      });
    }

  }

  // no validation
    // if (start === end) {
    //   _.set(config, 'modifiers.disabled', function(day) {
    //     if(day < start)
    //       return (day < startActual)
    //     if(day > end)
    //       return (day > end)
    //   });
    // }

    return config;
  }

  handleChange (day) {
    const value = day ? day.format('L') : '';
    this.props.onChange(value);
  }

  render () {
    const { value, errorText } = this.props;
    const dayPickerProps = this.getDatePickerPropsActual(value, this.limits)
    const tooltipClass = 'tooltip' + (this.state.hasFocus ? ' has-focus' : '')

    return (
      <div className={'date-field'}>
        <DayPickerInput
          value={getDateValue(value)}
          format="L"
          dayPickerProps={dayPickerProps}
          onDayChange={this.handleChange}
          onFocus={() => this.setState({hasFocus: true})}
          onBlur={() => this.setState({hasFocus: false})}
        />
        { errorText ? <div className={tooltipClass}>{errorText}</div> : null }
      </div>
    );
  }
}

DateFieldActual.defaultProps = {
  masterMode: false,
  errorText: '',
  isValid: true,
}

DateFieldActual.propTypes = {
  value: PropTypes.string,
  limits: PropTypes.object.isRequired,
  isValid: PropTypes.bool,
  errorText: PropTypes.string,
  masterMode: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};